import React from "react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";

import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";

const EditButtonWithLabel = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.secondaryColor}
      label={formatMessage({ id: "common.edit" })}
      iconName="edit"
      dataCy="edit-button"
      {...props}
    />
  );
};

export default EditButtonWithLabel;
